const getNotification = ({ reducer: { notification } }) => notification;

export const getType = (state) => getNotification(state).type;

export const getMessage = (state) => getNotification(state).message;
